import React, { useEffect, useState } from "react";
import { formadate } from "../../_App/Helpers/helpers";
import ClientType, {
  NiveauFideliteType,
} from "../../_App/Types/Entites/ClientType";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import {
  deleteNiveauClient,
  ListNiveauxFidelite,
} from "../../_App/Redux/Slices/client/clientSlice";
import { ToastSuccess } from "../../Shared/Toasts/ToastSuccess";
import { ToastWarning } from "../../Shared/Toasts/ToastWarning";
import Swal from "sweetalert2";
import { ToastDanger } from "../../Shared/Toasts/ToastDanger";
import { societeId } from "../../_App/Redux/Slices/Auth/authSlice";

export default function NiveauClientTable({
  Listclient,
  updateFunction,
  desactiveFunction,
  activeFunction,
  t,
}: any) {
  const niveaux = useAppSelector(ListNiveauxFidelite);
  const [keyword, setkeyword] = useState("");
  const societe = useAppSelector(societeId);

  // const handelsearch = () => {
  //   const lowercaseKeyword = keyword.toLowerCase();
  //   const listFiltrer = Listclient.filter(
  //     (item: any) =>
  //       item.nom.toLowerCase().includes(lowercaseKeyword) ||
  //       item.prenom.toLowerCase().includes(lowercaseKeyword)
  //   );

  //   setlist_client(listFiltrer);
  //   if (keyword === "") {
  //     setlist_client(Listclient);
  //   }
  // };
  const dispatch = useAppDispatch();
  const onDelete = async (category: NiveauFideliteType) => {
    const result = await Swal.fire({
      title: "Voulez vous vraiment supprimer cette categorie ?",
      text: "⚠️ Tous les clients de cette catégorie seront déplacés vers la catégorie par défaut",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
    });

    if (!result.isConfirmed || !category._id) return;

    try {
      const response = await dispatch(
        deleteNiveauClient({ id: category._id, societeID: societe }),
      );
      if (response.payload?.success) {
        ToastSuccess(response.payload.message);
      } else {
        ToastWarning(
          response.payload?.message || "Erreur lors de la suppression",
        );
      }
    } catch (error) {
      console.error("Delete error:", error);
      ToastDanger("Une erreur est survenue lors de la suppression");
    }
  };
  return (
    <div>
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th scope="col">{t("LIbelle")}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {niveaux.map((item: NiveauFideliteType, index: number) => (
              <tr key={index}>
                <td>{item.libelle}</td>
                <td>
                  <span
                    style={{
                      cursor: "pointer",
                      fontSize: "1.5em",
                      marginRight: "10px",
                    }}
                    onClick={() => updateFunction(item)}
                  >
                    <i className="fas fa-edit" style={{ color: "#06958d" }}></i>
                  </span>
                  <span
                    style={{
                      cursor: "pointer",
                      fontSize: "1.2em",
                      marginRight: "10px",
                    }}
                    onClick={() => onDelete(item)}
                    title={t("Bloquer")}
                  >
                    <i className="fas fa-times text-danger"></i>
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
